import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";

// Importa as imagens diretamente do caminho relativo
import auto from "../../assets/images/produtos/auto.webp";
import residencial from "../../assets/images/produtos/residencial.webp";
import vida from "../../assets/images/produtos/vida.webp";
import saude from "../../assets/images/produtos/saude.webp";
import previdencia from "../../assets/images/produtos/previdencia.webp";
import consorcio from "../../assets/images/produtos/consorcio.webp";
import agricola from "../../assets/images/produtos/agricola.webp";
import empresarial from "../../assets/images/produtos/empresarial.webp";

const services = [
  {
    image: auto,
    title: "Seguro Auto",
    description:
      "Proteção completa para seu veículo com assistência 24h, cobertura contra roubo, furto e danos.",
    link: "/auto",
  },
  {
    image: residencial,
    title: "Seguro Residencial",
    description: "Segurança para o seu lar e sua família.",
    link: "/residencial",
  },
  {
    image: vida,
    title: "Seguro de Vida",
    description:
      "Garanta o futuro de quem você ama com proteção financeira e tranquilidade.",
    link: "/vida",
  },
  {
    image: saude,
    title: "Plano de Saúde",
    description:
      "Acesso rápido a uma rede de hospitais e clínicas com cobertura completa.",
    link: "/saude",
  },
  {
    image: previdencia,
    title: "Previdência Privada",
    description: "Planeje seu futuro financeiro com segurança e flexibilidade.",
    link: "/previdencia",
  },
  {
    image: consorcio,
    title: "Consórcio",
    description: "Forma inteligente e planejada para adquirir bens sem juros.",
    link: "/consorcio",
  },
  {
    image: agricola,
    title: "Seguro Agrícola",
    description:
      "Proteção para sua produção rural contra riscos climáticos e outros.",
    link: "/agricola",
  },
  {
    image: empresarial,
    title: "Seguro Empresarial",
    description:
      "Proteja seu negócio com coberturas personalizadas e completas.",
    link: "/empresarial",
  },
];

function useOnScreen(ref) {
  const [isIntersecting, setIntersecting] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setIntersecting(entry.isIntersecting),
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [ref]);

  return isIntersecting;
}

const ServicesSection = () => {
  const titleRef = useRef();
  const titleVisible = useOnScreen(titleRef);

  return (
    <section id="servicos" className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        {/* Título e subtítulo com animação */}
        <div
          ref={titleRef}
          className={`max-w-3xl text-left mb-12 transition-opacity duration-700 ${
            titleVisible ? "fadeInUp" : "opacity-0"
          }`}
        >
          <h2 className="text-3xl sm:text-4xl font-bold text-blue-950 mb-4">
            Cuidamos do que importa pra você.
          </h2>
          <p className="text-lg sm:text-xl text-blue-950">
            Na Free Market, somos especialistas em seguros — e em entender{" "}
            <br />o que faz sentido pra você.
          </p>
        </div>

        {/* Grid de cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <FadeInCard key={index} service={service} />
          ))}
        </div>
      </div>

      {/* Estilos da animação fade-in */}
      <style jsx>{`
        @keyframes fadeInUp {
          0% {
            opacity: 0;
            transform: translateY(10px);
          }
          100% {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .fadeInUp {
          animation-name: fadeInUp;
          animation-duration: 600ms;
          animation-fill-mode: forwards;
          animation-timing-function: ease-out;
        }
      `}</style>
    </section>
  );
};

const FadeInCard = ({ service }) => {
  const ref = useRef();
  const onScreen = useOnScreen(ref);

  return (
    <div
      ref={ref}
      className={`transition-transform duration-300 hover:scale-[1.02] ${
        onScreen ? "fadeInUp" : "opacity-0"
      }`}
    >
      <Link
        to={service.link}
        className="block bg-white rounded-lg shadow-md p-6 text-center flex flex-col h-full hover:shadow-xl"
      >
        <img
          src={service.image}
          alt={service.title}
          className="mx-auto mb-4 w-38 h-38 object-contain rounded-3xl"
        />
        <h3 className="text-left text-xl font-semibold text-blue-900 mb-2">
          {service.title}
        </h3>
        <p className="text-left text-gray-700 mb-4">{service.description}</p>
        <div className="text-left mt-auto text-blue-700 font-medium hover:underline">
          Saiba mais →
        </div>
      </Link>
    </div>
  );
};

export default ServicesSection;
